import React, { Component } from 'react'
import Scroll from 'react-scroll'
import config from '../config.json'
import hasSlidebarRightAndSecond from '../hoc/hasSlidebarRightAndSecond'
import hasOpenInformationAndDetails from '../hoc/hasOpenInformationAndDetails'
import { trackMovieInformationOpen, trackMoviePerformanceOpen } from '../tracking'
import Showtimes from './Showtimes'
import ShowtimesHead from './ShowtimesHead'
import FilterMovieInformation from '../Overview/FilterResultsShowtimes/FilterMovieInformation'
const breakpoints = config.breakpoints

let Element = Scroll.Element

class SliderShowtimes extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentDateActive: '',
            showtimesOpen: false
        }

        this.toggleMovieDatesOnMobileView = this.toggleMovieDatesOnMobileView.bind(this)
        this.toggleShowtimes = this.toggleShowtimes.bind(this)
    }

    toggleMovieDatesOnMobileView(date) {        
        this.setState({
            currentDateActive: date
        })
    }

    toggleShowtimes() {
        this.setState({
            showtimesOpen: !this.state.showtimesOpen
        })

        this.props.onClosePerformancePage()
        this.props.onCloseInformation()

    }

    componentDidUpdate(prevProps) {
        const {currentActiveSelection, selectionId, activeItem, onCloseInformation} = this.props
        if (currentActiveSelection !== prevProps.currentActiveSelection) {
            if(currentActiveSelection && currentActiveSelection !== selectionId && activeItem) {
                onCloseInformation()
            }
        }
    }

    render() {
        const { 
            items, 
            moviesData, 
            scrollToPosition, 
            displaySidebarRightSecond, 
            showMovieTimesSortedAfterTheatres, 
            theme,
            title='',
            translation,
            activeItem, 
            activePerformance, 
            performancePageOpen,
            onOpenPerformancePage,
            isMobile,
            filterType,
            filterValue,
            programOverviewShowtimesType,
            onClosePerformancePage
        } = this.props
        
        const { currentDateActive, showtimesOpen } = this.state
   
        const eventOrigins = {
            highlight:                  'Startseite, Showtimes "' + title + '", Showtimes',
            information:                'Startseite, Showtimes "' + title + '", Film Information',
            informationSlidebar:        'Startseite, Showtimes "' + title + '", Film Imformation/rechte Slidebar',
            performance:                'Startseite, Showtimes "' + title + '", Film Vorführung',
            performanceSlidebar:        'Startseite, Showtimes "' + title + '", Film Vorführung/rechte Slidebar',
            details:                    'Startseite, Showtimes "' + title + '", Film Details',
            detailsSlidebar:            'Startseite, Showtimes "' + title + '", Film Details/rechte Slidebar',
        }

         return (
            <div className={scrollToPosition}>
                <div className={"slider-wrapper"}>

                    <ShowtimesHead
                        title={title}
                        items={items}
                        moviesData={moviesData}
                        translation={translation}
                        scrollToPosition={scrollToPosition}
                        showtimesOpen={showtimesOpen}
                        onToggleShowtimes={trackMovieInformationOpen(this.toggleShowtimes, eventOrigins.highlight)}
                    />

                    
                    <Element name={scrollToPosition}></Element>
                    {showtimesOpen && <Showtimes 
                        items={items}
                        moviesData={moviesData}
                        translation={translation}
                        scrollToPosition={scrollToPosition}
                        programOverviewShowtimesType={programOverviewShowtimesType}
                        additionalScrollName=''
                        hasTitle={true}
                        filterPerformances={false}
                        onClickItem={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.highlight)}
                    />}

                    <Element name={scrollToPosition + ' movieInformation'}></Element>
                    <FilterMovieInformation
                        activeItem={activeItem}
                        isMobile={isMobile}
                        additionalScrollName=''
                        filterValue={filterValue}
                        filterType={filterType}
                        itemsData={moviesData}
                        displaySidebarRightSecond={displaySidebarRightSecond} 
                        toggleMovieDatesOnMobileView={this.toggleMovieDatesOnMobileView}
                        currentDateActive = {currentDateActive}
                        activePerformance={activePerformance}
                        performancePageOpen={performancePageOpen}
                        onOpenPerformancePage={onOpenPerformancePage}
                        onClosePerformancePage={onClosePerformancePage}
                        showMovieTimesSortedAfterTheatres={showMovieTimesSortedAfterTheatres}
                        theme={theme}
                        eventOrigins={eventOrigins}
                        translation={translation}
                    />
                </div>
            </div>
        )
    }
}


export default hasSlidebarRightAndSecond({breakpoint:  breakpoints.slidebarRight})(hasOpenInformationAndDetails(SliderShowtimes))